import { Check } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { PROBLEM } from "../../lib/content";

export const Problem = () => (
  <section className="relative py-24 md:py-36" data-testid="problem-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 grid md:grid-cols-12 gap-12 items-start">
      <div className="md:col-span-5">
        <Reveal>
          <Overline>{PROBLEM.overline}</Overline>
          <h2 className="mt-6 font-display text-4xl md:text-5xl font-extrabold leading-[1.05] tracking-tight">
            {PROBLEM.title}
          </h2>
          <p className="mt-6 text-white/60 text-lg leading-relaxed">{PROBLEM.body}</p>
        </Reveal>
      </div>

      <div className="md:col-span-7 md:pl-8">
        <div className="grid gap-4">
          {PROBLEM.pains.map((p, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="group flex items-start gap-4 rounded-2xl border border-white/10 bg-bf-surface p-6 hover:border-bf-yellow/40 transition-colors duration-300">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-bf-yellow/10 text-bf-yellow">
                  <Check size={16} />
                </span>
                <p className="text-white/75 leading-relaxed">{p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
